import { $ } from "../shared/jquery-globals";
import { initOtpInput } from "../modules/otp-input";

window.initOtpInput = initOtpInput;

$(function () {
  if ($('[data-module="otp-input"]').length) {
    initOtpInput();
  }
});
